/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Remove_Set_HintInputs */

const en_us2_workout_remove_set_hint = /** @type {(inputs: Workout_Remove_Set_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove a set (today only)`)
};

const pt_br2_workout_remove_set_hint = /** @type {(inputs: Workout_Remove_Set_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retirar uma série (só hoje)`)
};

const es_419_workout_remove_set_hint = /** @type {(inputs: Workout_Remove_Set_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quitar una serie (solo hoy)`)
};

const pt_pt2_workout_remove_set_hint = /** @type {(inputs: Workout_Remove_Set_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retirar uma série (só hoje)`)
};

const fr_fr2_workout_remove_set_hint = /** @type {(inputs: Workout_Remove_Set_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retirer une série (aujourd'hui seulement)`)
};

const de_de2_workout_remove_set_hint = /** @type {(inputs: Workout_Remove_Set_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einen Satz entfernen (nur heute)`)
};

const it_it2_workout_remove_set_hint = /** @type {(inputs: Workout_Remove_Set_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Togli una serie (solo oggi)`)
};

/**
* | output |
* | --- |
* | "Remove a set (today only)" |
*
* @param {Workout_Remove_Set_HintInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_remove_set_hint = /** @type {((inputs?: Workout_Remove_Set_HintInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Remove_Set_HintInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_remove_set_hint(inputs)
	if (locale === "es-419") return es_419_workout_remove_set_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_remove_set_hint(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_remove_set_hint(inputs)
	if (locale === "de-DE") return de_de2_workout_remove_set_hint(inputs)
	if (locale === "it-IT") return it_it2_workout_remove_set_hint(inputs)
	return en_us2_workout_remove_set_hint(inputs)
});
export { workout_remove_set_hint as "workout.remove_set_hint" }